import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import Image from 'next/image';
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";

import { UserContext } from "../../context";
import { logoDark, proLogoDark } from "../../assets";

const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: "rgba(0,0,0,0.65)",
    color: "rgba(255,255,255,1)",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(12.5),
    padding: ".35rem .75rem",
    borderRadius: "8px",
  },
}));

export default function PracticeNavbar({
  title,
  chapterID,
  examCompletionStatus,
}) {
  const [isUserProTier] = useContext(UserContext).tier;
  const [progressValue, setProgressValue] = useState(0);
  const [pathColor, setPathColor] = useState("white");
  const [trailColor, setTrailColor] = useState("rgba(255,255,255,0.25)");

  const tooltipClasses = useStylesBootstrap();
  const [subjectName, setSubjectName] = useState("");

  useEffect(() => {
    if (chapterID) {
      const parts = chapterID.split("_");

      const subjectMap = {
        science: "Science",
        maths: "Mathematics",
        mathematics: "Mathematics",
        socialscience: "Social Science",
        english: "English",
        hindi: "Hindi",
      };
      // Find the subject part (like "science", "maths", etc.)
      const subjectParts = parts.filter((part) =>
        Object.keys(subjectMap).includes(part.toLowerCase())
      );

      if (subjectParts.length > 0) {
        // Capitalize the first letter of the subject
        const subject = subjectParts[0];
        setSubjectName(subjectMap[subject]);
      }
    }
  }, [chapterID]);

  useEffect(() => {
    const totalLectures = examCompletionStatus?.total_item_count;

    const completedLectures = examCompletionStatus?.completed_item_count;

    const value =
      completedLectures && totalLectures
        ? (completedLectures / totalLectures) * 100
        : 0;

    setProgressValue(value);

    if (value === 0) {
      setPathColor("white");
      setTrailColor("rgba(255, 255, 255, 0.25)");
    }
    if (value > 0 && value <= 90) {
      setPathColor("rgba(0, 255, 0, 1)");
      setTrailColor("rgba(0, 255, 0, 0.25)");
    }
    if (value > 90) {
      setPathColor("rgba(255, 215, 0, 1)");
      setTrailColor("rgba(255, 215, 0, 0.25)");
    }
  }, [chapterID, examCompletionStatus]);

  const progressBarStyles = buildStyles({
    rotation: 0,
    strokeLinecap: "round",
    textSize: "16px",
    pathTransitionDuration: 1.5,
    pathColor: pathColor,
    trailColor: trailColor,
    backgroundColor: "#3e98c7",
  });

  return (
    <div className="classroom__navbar">
      <Link to="/">
        <div className="classroom__logo">
          {isUserProTier ? (
            <img
              className="header__leftImage"
              src={proLogoDark}
              alt="PuStack Pro"
              draggable={false}
            />
          ) : (
            <img
              className="header__leftImage"
              src={logoDark}
              alt="PuStack"
              draggable={false}
            />
          )}
        </div>
      </Link>

      {title && (
        <>
          <div className="separator">|</div>
          <div
            className="classroom__breadcrumb"
            style={{ display: "flex", alignItems: "center" }}
          >
            {subjectName && (
              <>
                <div
                  className="classroom__subject__name"
                  style={{
                    color: "rgba(255, 255, 255, 0.7)",
                    fontWeight: 500,
                    fontSize: "1.1rem",
                  }}
                >
                  {subjectName}
                </div>

                <div
                  className="breadcrumb-separator"
                  style={{
                    margin: "0 8px",
                    color: "rgba(255, 255, 255, 0.5)",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 18L15 12L9 6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </>
            )}

            <div
              className="classroom__chapter__name"
              style={{ fontWeight: 600 }}
            >
              {title}
            </div>
          </div>
        </>
      )}

      <Tooltip
        title={`${Math.round(progressValue)}% completed`}
        classes={tooltipClasses}
        placement={"bottom"}
        enterTouchDelay={0}
      >
        <div className="classroom__progress">
          <CircularProgressbarWithChildren
            value={progressValue}
            styles={progressBarStyles}
            strokeWidth={7}
          >
            {/* <svg
							width={19}
							height={19}
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							className={progressValue > 90 ? 'trophy cup__golden' : 'trophy'}
						>
							<path
								d="M17.807 3.835a16.046 16.046 0 0 1-.003-.272h-3c.058-1.285.02-2.376.02-2.376H9.532c-.013 0-.025.001-.038.003a.362.362 0 0 0-.037-.002H4.154s-.039 1.09.02 2.375H1.186V4.75h.006c.03.968.185 2.264.83 3.59a7.44 7.44 0 0 0 2.337 2.796 8.105 8.105 0 0 0 2.828 1.302c.603.644 1.199 1 1.718 1.142v1.322c-.074.393-.524 1.723-3.665 1.723H4.75v1.188h9.5v-1.188h-.489c-3.684 0-3.667-1.83-3.667-1.83V13.58c.52-.142 1.103-.496 1.703-1.137a8.09 8.09 0 0 0 2.844-1.307 7.44 7.44 0 0 0 2.337-2.796c.88-1.81.847-3.563.83-4.505ZM3.09 7.821c-.537-1.105-.677-2.218-.708-3.071h1.873c.033.33.073.657.125.964.316 1.882.75 3.544 1.572 5.01A6.309 6.309 0 0 1 3.09 7.821Zm12.82 0a6.31 6.31 0 0 1-2.884 2.915c.824-1.47 1.255-3.135 1.571-5.022.052-.307.093-.633.125-.964h1.896c-.03.853-.171 1.966-.708 3.07Z"
								fill="#000"
							/>
						</svg> */}
            <i
              className={
                progressValue > 90
                  ? "fas fa-trophy cup__golden"
                  : "fas fa-trophy"
              }
              style={{ color: pathColor }}
            ></i>
          </CircularProgressbarWithChildren>
        </div>
      </Tooltip>
    </div>
  );
}
